.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1lh 1rem;
  min-height: 100vh;
}

.content {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  margin: 0 auto;
}

.links {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0 0.25rem;
}

.link {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  color: var(--fg);
  text-decoration: none;
  width: 5.25rem;
  height: 6rem;
  gap: 0.25rem;
  z-index: 0;
  transition:
    color 0.5s ease-in-out,
    scale 0.5s ease-in-out;
}

.link-icon {
  font-size: 3rem;
  stroke-width: 0.75;
}

.link-label {
  font-size: 1rem;
  text-align: center;
  line-height: 1.4;
}

@media (hover: hover) {
  .link:hover {
    color: var(--fg-lit);
    scale: 1.1;
    z-index: 1;
  }

  .link:hover .link-label {
    opacity: 1;
  }
}
